import React from 'react';
import ReactTooltip from 'react-tooltip';
import { TextInputField } from '../../../../../shared/form/inputs/TextInputField';
import { ManifoldFormModel } from '../../manifolds/manifoldFormModel';
import { roomFieldName } from '../../quoteOrDesignFormFieldNameHelpers';
import { RoomFormModel } from '../roomFormModel';
import { ReactComponent as UpdateDisabled } from '../../../../../images/icons/update_disabled.svg';

type Props = {
  unitIndex: number;
  manifoldIndex: number;
  manifold: ManifoldFormModel;
  roomIndex: number;
  isWithinRadiatorManifold: boolean;
  room: RoomFormModel;
  onChange?: (newValue: string) => void;
  onInput?: () => void;
};

export const RoomNumberOfPortsField = ({
  unitIndex,
  manifoldIndex,
  manifold,
  roomIndex,
  isWithinRadiatorManifold,
  room,
  onChange,
  onInput,
}: Props) => {
  if (room.floorConstruction != null && room.floorConstruction.isElectricUnderfloorHeating) {
    return null;
  }

  if (isWithinRadiatorManifold) {
    return null;
  }

  const labelIcon = manifold.designManifoldDetails?.disableNumberOfPortsAndPipesPerPortCalculation ? (
    <>
      <UpdateDisabled data-tip="Automatic calculation disabled" />
      <ReactTooltip effect="solid" clickable={true} />
    </>
  ) : null;

  return (
    <TextInputField
      name={roomFieldName(unitIndex, manifoldIndex, roomIndex, 'numberOfPorts')}
      label="Ports"
      labelIcon={labelIcon}
      onChange={onChange}
      onInput={onInput}
    />
  );
};
